import React, { useState } from 'react';
import './FaqSection.css';

const FaqSection = () => {
  const [openAccordions, setOpenAccordions] = useState(new Array(3).fill(false));

  const toggleAccordion = (index) => {
    setOpenAccordions(prev => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <div className="faq-section section-container">
      <div className="faq-max-width max-width">
        <div className="faq-content">
          <div className="faq-questions">
            <span className="faq-label beforeHeading">faq</span>
            <h1 className="faq-headline">
              <span className="faq-text">
                Frequently Asked
                <span dangerouslySetInnerHTML={{ __html: ' ' }} />
              </span>
              <br></br>
              <span className="faq-highlight">Questions</span>
            </h1>
            
            <div data-role="Accordion" className="question">
              <div 
                data-type="accordion-header" 
                className="faq-trigger"
                onClick={() => toggleAccordion(0)}
                style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center'
                }}
              >
                <span className="faq-question-text">Where do you operate?</span>
                <svg viewBox="0 0 1024 1024" className="faq-icon">
                  <path d="M810 554h-256v256h-84v-256h-256v-84h256v-256h84v256h256v84z"></path>
                </svg>
              </div>
              <div 
                data-type="accordion-content" 
                className={`question-content ${openAccordions[0] ? 'open' : ''}`}
              >
                <span className="faq-answer-text">
                  We are currently operating in the Bay Area, CA. We are looking to expand to other locations soon, please contact us to find out more.
                </span>
              </div>
            </div>
            
            <div data-role="Accordion" className="question">
              <div 
                data-type="accordion-header" 
                className="faq-trigger"
                onClick={() => toggleAccordion(1)}
                style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center'
                }}
              >
                <span className="faq-question-text">What payment methods do you accept?</span>
                <svg viewBox="0 0 1024 1024" className="faq-icon">
                  <path d="M810 554h-256v256h-84v-256h-256v-84h256v-256h84v256h256v84z"></path>
                </svg>
              </div>
              <div 
                data-type="accordion-content" 
                className={`question-content ${openAccordions[1] ? 'open' : ''}`}
              >
                <span className="faq-answer-text">
                  Only tap to pay is currently supported. Amex, Discover, Mastercard, Visa, Apple Pay, Google Pay, and Samsung Pay are all accepted.
                </span>
              </div>
            </div>
            
            <div data-role="Accordion" className="question">
              <div 
                data-type="accordion-header" 
                className="faq-trigger"
                onClick={() => toggleAccordion(2)}
                style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center'
                }}
              >
                <span className="faq-question-text">What does the installation process look like?</span>
                <svg viewBox="0 0 1024 1024" className="faq-icon">
                  <path d="M810 554h-256v256h-84v-256h-256v-84h256v-256h84v256h256v84z"></path>
                </svg>
              </div>
              <div 
                data-type="accordion-content" 
                className={`question-content ${openAccordions[2] ? 'open' : ''}`}
              >
                <span className="faq-answer-text">
                  Installation is easy to adjust and takes ~30 minutes. Choose the right base type for your location and we will install and service your block free of charge.
                </span>
              </div>
            </div>
          </div>
          <img
            alt="image"
            src="/enclosure_2.png"
            className="faq-image"
          />
        </div>
      </div>
    </div>
  );
};

export default FaqSection;